var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./DraftDelete.jinja');
require('./DraftDelete.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click .DraftDelete-yesButton': 'onYesClick',
        'click .DraftDelete-noButton': 'onNoClick',
        'click': 'onBGClick'
    },


    initialize: function (options) {

        _.bindAll(this, 'onKeyDown');

        Base.prototype.initialize.call(this, options);
    },


    show: function (params) {
        params = params || {};

        $('body').on('keydown', this.onKeyDown);

        this.cb = params.cb;
        this.$el.addClass('DraftDelete--visible');
    },


    hide: function () {
        $('body').off('keydown', this.onKeyDown);

        this.$el.removeClass('DraftDelete--visible');
    },


    onBGClick: function (e) {
        if ($(e.target).closest('.DraftDelete-body').length) return;

        this.onNoClick();
    },

    onKeyDown: function (e) {
        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.onNoClick();
        }
    },


    onNoClick: function () {
        this.hide();

        this.cb && this.cb(false);
    },


    onYesClick: function () {
        this.hide();

        this.cb && this.cb(true);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/DraftDelete/DraftDelete.js
// module id = 105
// module chunks = 0